import React from 'react';
import PropTypes from 'prop-types';
/**
 * Primary UI component for user interaction
 */
const Input = ({
  value, placeholder, type, onChange, dataTestId, name, onClick, className, disabled, autoFocus,
  inputRef, onKeyDown, title, minLength, maxLength,
}) => (
  <input
    name={name}
    type={type}
    value={value}
    className={disabled ? `${className} text-gray-600` : className}
    placeholder={placeholder}
    onChange={onChange}
    onClick={onClick}
    // eslint-disable-next-line jsx-a11y/no-autofocus
    autoFocus={autoFocus}
    onKeyDown={onKeyDown}
    data-testid={dataTestId}
    disabled={disabled}
    ref={inputRef}
    title={title}
    minLength={minLength}
    maxLength={maxLength}
  />
);

Input.propTypes = {
  value: PropTypes.string.isRequired,
  /**
   * Input placeholder
   */
  placeholder: PropTypes.string,
  /**
   * One of the HTML5 input types from the list
   */
  type: PropTypes.oneOf(['text', 'email', 'password', 'number']).isRequired,
  onChange: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func,
  onClick: PropTypes.func,
  name: PropTypes.string,
  dataTestId: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  inputRef: PropTypes.func,
  title: PropTypes.string,
  autoFocus: PropTypes.bool,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
};

Input.defaultProps = {
  placeholder: '',
  name: undefined,
  dataTestId: null,
  onClick: null,
  disabled: false,
  className: 'border border-gray-500 border-opacity-25 sm:px-6 sm:py-3 px-4 py-2 rounded-2xl bg-gray-500 bg-opacity-5 placeholder-gray-700 w-full focus:outline-none',
  inputRef: null,
  onKeyDown: null,
  title: null,
  autoFocus: false,
  minLength: null,
  maxLength: null,
};

export default Input;
